import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ParentMessagesSender } from '../services/parent-messages-sender';

@Directive({
  selector: '[appResizeObserver]',
  standalone: true,
})
export class ResizeObserverDirective implements OnInit, OnDestroy {
  private observer!: ResizeObserver;

  constructor(
    private el: ElementRef,
    private parentMessagesSender: ParentMessagesSender,
  ) {}

  ngOnInit() {
    this.observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        this.parentMessagesSender.sendResize(height);
      }
    });
    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }
}
